import { render, staticRenderFns } from "./Select35.vue?vue&type=template&id=0872591c&scoped=true&"
import script from "./Select35.vue?vue&type=script&lang=ts&"
export * from "./Select35.vue?vue&type=script&lang=ts&"
import style0 from "./Select35.vue?vue&type=style&index=0&id=0872591c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0872591c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol})
